import { render, staticRenderFns } from "./InputSelectOption.vue?vue&type=template&id=c84ae96c&scoped=true&"
import script from "./InputSelectOption.vue?vue&type=script&lang=ts&"
export * from "./InputSelectOption.vue?vue&type=script&lang=ts&"
import style0 from "./InputSelectOption.vue?vue&type=style&index=0&id=c84ae96c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84ae96c",
  null
  
)

export default component.exports